/* ============================================================ */
/* JELLZY LANDING PAGE JS — v4                                   */
/* - Image gallery navigation (dots + thumbnails)                */
/* - Duo picker: tap hearts → resolve variant ID → enable submit */
/* - Sticky bar visibility on scroll                             */
/* - Headline URL param swap (?v=a/b/c)                          */
/* - FAQ accordion uses native <details>, no JS needed           */
/* ============================================================ */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init () {
    swapHeadline();
    initImageGallery();
    initDuoPicker();
    initSinglePicker();
  }

  /* === HEADLINE URL PARAM (for ad A/B testing) === */
  function swapHeadline () {
    var page = document.querySelector('.jl-page');
    if (!page) return;

    var params = new URLSearchParams(window.location.search);
    var variant = (params.get('v') || 'a').toLowerCase();

    var headlines = {
      a: page.dataset.headlineA,
      b: page.dataset.headlineB,
      c: page.dataset.headlineC
    };

    var target = document.querySelector('[data-headline-target]');
    if (target && headlines[variant] && variant !== 'a') {
      target.textContent = headlines[variant];
    }
  }

  /* === IMAGE GALLERY === */
  function initImageGallery () {
    var gallery = document.querySelector('[data-jl-gallery]');
    if (!gallery) return;

    var slides = gallery.querySelectorAll('.jl-gallery-slide');
    var dots = gallery.querySelectorAll('.jl-gallery-dot');
    var thumbs = gallery.querySelectorAll('.jl-gallery-thumb');
    var main = gallery.querySelector('[data-gallery-main]');
    if (!slides.length) return;

    var currentIndex = 0;

    function showSlide (index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });

      currentIndex = index;
    }

    /* Dot clicks */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.dataset.dot, 10);
        if (!isNaN(i)) showSlide(i);
      });
    });

    /* Thumbnail clicks */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = parseInt(thumb.dataset.thumb, 10);
        if (!isNaN(i)) showSlide(i);
      });
    });

    /* Touch swipe on mobile */
    if (main) {
      var touchStartX = 0;
      var touchEndX = 0;

      main.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      main.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) showSlide(currentIndex + 1);
          else showSlide(currentIndex - 1);
        }
      }, { passive: true });
    }

    /* Keyboard navigation */
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') showSlide(currentIndex - 1);
      if (e.key === 'ArrowRight') showSlide(currentIndex + 1);
    });
  }

  /* === DUO PICKER === */
  function initDuoPicker () {
    var forms = document.querySelectorAll('[data-duo-form]');
    if (!forms.length) {
      console.log('[jellzy] no duo form found');
      return;
    }

    forms.forEach(function (form) {

      var slot1Buttons = form.querySelectorAll('[data-duo-slot="1"] .jl-heart-btn');
      var slot2Buttons = form.querySelectorAll('[data-duo-slot="2"] .jl-heart-btn');
      var hiddenInput = form.querySelector('[data-duo-variant-id]');
      var submitBtn = form.querySelector('[data-duo-submit]');
      var variantsScript = form.querySelector('[data-duo-variants]');

      if (!variantsScript || !hiddenInput || !submitBtn) {
        console.log('[jellzy] missing duo elements');
        return;
      }

      var variantMap = {};
      try {
        variantMap = JSON.parse(variantsScript.textContent);
        console.log('[jellzy] duo variants loaded:', variantMap);
      } catch (e) {
        console.error('[jellzy] could not parse duo variants', e);
        return;
      }

      var selected = { 1: null, 2: null };

      // ✦ Toggle expand/collapse
      var toggle = form.querySelector('[data-duo-toggle]');
      var content = form.querySelector('.jl-duo-content');
      var chevron = form.querySelector('.jl-tier-chevron');

      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          var isCollapsed = form.classList.contains('jl-tier-collapsed');
          if (isCollapsed) {
            form.classList.remove('jl-tier-collapsed');
            content.style.display = 'block';
            if (chevron) chevron.style.transform = 'translateY(-50%) rotate(180deg)';
          } else {
            form.classList.add('jl-tier-collapsed');
            content.style.display = 'none';
            if (chevron) chevron.style.transform = 'translateY(-50%) rotate(0deg)';
          }
        });
      }

      function bindSlot (buttons, slotNum) {
        buttons.forEach(function (btn) {
          btn.setAttribute('aria-pressed', 'false');
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            selected[slotNum] = btn.dataset.color;
            updateSubmitState();
          });
        });
      }

      function updateSubmitState () {
        if (selected[1] && selected[2]) {
          var key = selected[1] + '+' + selected[2];
          var keyRev = selected[2] + '+' + selected[1];
          var variantId = variantMap[key] || variantMap[keyRev];

          if (variantId) {
            hiddenInput.value = variantId;
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to cart — ' + getDuoPriceText();
          } else {
            hiddenInput.value = '';
            submitBtn.disabled = true;
            submitBtn.textContent = 'Combination unavailable';
            console.log('[jellzy] no variant for keys:', key, 'or', keyRev);
          }
        } else {
          hiddenInput.value = '';
          submitBtn.disabled = true;
          submitBtn.textContent = 'Pick 2 hearts to continue';
        }
      }

      function getDuoPriceText () {
        var priceEl = form.querySelector('.jl-tier-sec-price-big');
        return priceEl ? priceEl.textContent.trim() : '';
      }

      bindSlot(slot1Buttons, 1);
      bindSlot(slot2Buttons, 2);

      // ✦ Intercept submit — fetch instead of native POST
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var variantId = hiddenInput.value;
        if (!variantId) return;

        // Loading state
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
        submitBtn.style.opacity = '0.65';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Cart error'); });
          return res.json();
        })
        .then(function () {
          submitBtn.textContent = 'Added ✓';
          submitBtn.style.opacity = '1';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () { window.location.href = '/cart'; }, 1000);
        })
        .catch(function (err) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
          submitBtn.style.color = 'var(--color-text-danger)';
          submitBtn.textContent = err.message || 'Could not add — try again';
          setTimeout(function () {
            submitBtn.style.color = '';
            updateSubmitState();
          }, 3000);
        });
      });

    }); // end forms.forEach
  }

  /* === SINGLE PICKER === */
  function initSinglePicker () {
    var forms = document.querySelectorAll('[data-single-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {

      var buttons = form.querySelectorAll('[data-single-slot] .jl-heart-btn');
      var hiddenInput = form.querySelector('[data-single-variant-id]');
      var submitBtn = form.querySelector('[data-single-submit]');
      var variantsScript = form.querySelector('[data-single-variants]');

      if (!variantsScript || !hiddenInput || !submitBtn) {
        console.log('[jellzy] missing single elements');
        return;
      }

      var variantMap = {};
      try {
        variantMap = JSON.parse(variantsScript.textContent);
        console.log('[jellzy] single variants loaded:', variantMap);
      } catch (e) {
        console.error('[jellzy] could not parse single variants', e);
        return;
      }

      var selected = null;

      // Toggle expand/collapse
      var toggle = form.querySelector('[data-single-toggle]');
      var content = form.querySelector('.jl-single-content');
      var chevron = form.querySelector('.jl-tier-chevron');

      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          var isCollapsed = form.classList.contains('jl-tier-collapsed');
          if (isCollapsed) {
            form.classList.remove('jl-tier-collapsed');
            content.style.display = 'block';
            if (chevron) chevron.style.transform = 'translateY(-50%) rotate(180deg)';
          } else {
            form.classList.add('jl-tier-collapsed');
            content.style.display = 'none';
            if (chevron) chevron.style.transform = 'translateY(-50%) rotate(0deg)';
          }
        });
      }

      // Heart button selection
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', 'false');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          selected = btn.dataset.color;
          updateSubmitState();
        });
      });

      function updateSubmitState () {
        if (selected && variantMap[selected]) {
          hiddenInput.value = variantMap[selected];
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add to cart — ' + getPriceText();
        } else {
          hiddenInput.value = '';
          submitBtn.disabled = true;
          submitBtn.textContent = 'Pick a color to continue';
        }
      }

      function getPriceText () {
        var priceEl = form.querySelector('.jl-tier-sec-price-big');
        return priceEl ? priceEl.textContent.trim() : '';
      }

      // Intercept submit — fetch instead of native POST
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var variantId = hiddenInput.value;
        if (!variantId) return;

        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
        submitBtn.style.opacity = '0.65';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Cart error'); });
          return res.json();
        })
        .then(function () {
          submitBtn.textContent = 'Added ✓';
          submitBtn.style.opacity = '1';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () { window.location.href = '/cart'; }, 1000);
        })
        .catch(function (err) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
          submitBtn.style.color = 'var(--color-text-danger)';
          submitBtn.textContent = err.message || 'Could not add — try again';
          setTimeout(function () {
            submitBtn.style.color = '';
            updateSubmitState();
          }, 3000);
        });
      });

    }); // end forms.forEach
  }


})();